import React from 'react'
import PropTypes from 'prop-types'

const ContentItemSelectionMessage = props => {
  const message = props.acceptMultiple
    ? 'Select which items you would like to import'
    : 'Select a single item you would like to import'
  return (
    <div>
      <div>
        <div className="text-center">
          <img src="/static/base_app/media/logos/wordmark-blue-300.png" />
        </div>
        <p className="mt-5 mb-5 text-center lead">{message}</p>
      </div>
    </div>
  )
}

ContentItemSelectionMessage.propTypes = {
  acceptMultiple: PropTypes.bool,
}

export default ContentItemSelectionMessage
